import WebFont from 'webfontloader';
import map from 'lodash/map';

const fontsLoading: string[] = [];
const fontsLoaded: string[] = [];

interface IFontCallback {
    font: string,
    callback: () => void
}
const waitingFonts: IFontCallback[] = [];
export const loadFont = (font: string, callback?: () => void): void => {
    if (callback) waitingFonts.push({ font, callback });
    if (!fontsLoading.includes(font)) {
        fontsLoading.push(font);
        WebFont.load({
            google: { families: [`${font}:400,700`] },
            fontactive: () => {
                if (!fontsLoaded.includes(font)) {
                    fontsLoaded.push(font);
                    waitingFonts.forEach((f) => {
                        if (f.font === font) f.callback();
                    });
                }
            }
        });
    }
};

export interface FontName {
    id: string,
}

export let FontNames: FontName[] = [];
export const getGoogleFonts = (callback?: () => void): void => {
    fetch('https://www.googleapis.com/webfonts/v1/webfonts?sort=popularity&key=AIzaSyDwXUFOSFMF44soDpKz2WbHKelntWtl9yU')
        .then((res) => res.json())
        .then(
            (result) => {
                const list = result.items;
                FontNames = map(list, (f) => ({ id: f.family }));
                setTimeout(() => {
                    if (callback) callback();
                }, 50);
            },
            // Remarque : il est important de traiter les erreurs ici
            // au lieu d'utiliser un bloc catch(), pour ne pas passer à la trappe
            // des exceptions provenant de réels bugs du composant.
            (error) => {
                console.log(error);
            }
        )
        .catch((error) => {
            console.log(error);
        });
};
